import { useTranslation } from "react-i18next";
import Dialog from "components/shared/Dialog";
import SimpleTable from "components/shared/tables/SimpleTable";
import { useCompanyDateFormat } from "utils/hooks/company";
import { useColumns } from "./useColumns";

interface Props {
    isOpen: boolean;
    close: () => void;
    values: any;
}

function InfoModal({ isOpen, close, values }: Props) {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();
    const columns = useColumns({ dateFormat });

    return (
        <Dialog title={t("info")} open={isOpen} close={close} size="lg">
            <SimpleTable data={values || []} columns={columns} />
        </Dialog>
    );
}

export default InfoModal;
